import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {distinctUntilChanged, map, Observable} from 'rxjs';
import {PortalMessageBroker} from './portal/portal-message-broker';
import {IntentActionService} from './services/intent.action.service';
import {PreloadModulesService} from './services/preload-modules.services';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Theme, ThemeService} from '@adnova/jf-ng-components';
import {ContextInfoService, WellKnownShellProperties} from './portal/context-info.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  private _destroyRef = inject(DestroyRef);
  private _portalMessageBroker = inject(PortalMessageBroker);
  private _oidcSecurityService = inject(OidcSecurityService);
  private _intentActionService = inject(IntentActionService);
  private _preloadModulesService = inject(PreloadModulesService);
  private _themeService = inject(ThemeService);
  private _contextInfoService = inject(ContextInfoService);

  runningInPortal$: Observable<boolean>;

  runningInIFrame$: Observable<boolean>;

  constructor() {
    this.runningInPortal$ = this._portalMessageBroker.runningInPortal$.pipe(
      takeUntilDestroyed(this._destroyRef),
    );

    this.runningInIFrame$ = this._portalMessageBroker.runningInIFrame$.pipe(
      takeUntilDestroyed(this._destroyRef),
    );

    this._contextInfoService.contextInfo$
      .pipe(
        map(info => info.properties.get(WellKnownShellProperties.SHELL_MODE) as string | undefined),
        distinctUntilChanged(),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe(mode => {
        if (mode && Object.values<string>(Theme).includes(mode)) {
          this._themeService.setTheme(mode as Theme);
        }
      });
  }

  ngOnInit(): void {
    /*
     * INFO: In der folgenden Zeile wird die preloadModules Methode des PreloadModulesService aufgerufen,
     * um die vordefinierten Module vorzuladen.
     */
    this._preloadModulesService.preloadModules();
  }

  doLogout(): void {
    this._oidcSecurityService.logoff();
  }

}
